export default __webpack_public_path__ + "9dc6b784c88381e70f6629b7b4f01a1a.png";